/*
 *   File : webinarPreview.js
 *   Author URI : https://evoqueinnovativelab.com
 *   Description : Single shared renderer for the `webinar_invite` WhatsApp
 *                 template preview (header image + caption + REGISTER button).
 *                 Used by both the send/compose preview (containers/notification)
 *                 and the history "View content" modal so the markup is never
 *                 duplicated.
 *   Version : v1.0
 */

import React from 'react';
import { buildWebinarCaptionHtml } from '../../config/webinarTemplate';
import FallbackImage from './fallbackImage';

/**
 * @param {string}   image    - header image url
 * @param {string}   url      - registration url for the REGISTER button
 * @param {string[]} contents - content_one..content_seven values
 */
const WebinarPreview = ({ image, url, contents = [] }) => {
    return (
        <>
            <div className='e-w-message-section'>
                {/* Header image: keep the original aspect ratio (full card width,
                    auto height) like WhatsApp renders image headers — never stretch.
                    Falls back to the placeholder when empty or if the image fails to load. */}
                <div className='e-webinar-header mb-2'>
                    <FallbackImage
                        src={image}
                        alt="webinar header"
                        style={{
                            width: '100%',
                            height: 'auto',
                            maxHeight: '200px',
                            display: 'block',
                            borderRadius: '8px',
                            objectFit: 'contain',
                        }}
                    />
                </div>

                <div className='e-text-container'>
                    <p dangerouslySetInnerHTML={{ __html: buildWebinarCaptionHtml(contents) }} />
                </div>
            </div>

            <div className='e-template-button text-center'>
                <p>
                    <a href={url || '#'} target="_blank" rel="noreferrer">
                        🔗 REGISTER
                    </a>
                </p>
            </div>
        </>
    );
};

export default WebinarPreview;
